import { BreadcrumbPopover } from './Popovers/BreadcrumbPopover'
import { LoadDropPopover } from './Popovers/LoadDropPopover'
import { PoiPopover } from './Popovers/PoiPopover'
import type { PopoverInfo } from '../types'
import { DriverPopover } from './Popovers/DriverPopover'

type MapPopoverProps = {
  popoverInfo: PopoverInfo | null
  mapRef: React.MutableRefObject<mapboxgl.Map | null>
}

export function MapPopover({ popoverInfo, mapRef }: MapPopoverProps) {
  if (!popoverInfo) {
    return null
  }

  switch (popoverInfo.popoverType) {
    case 'breadcrumb':
      return <BreadcrumbPopover hoverInfo={popoverInfo} />
    case 'load-drop':
      return <LoadDropPopover hoverInfo={popoverInfo} />
    case 'poi':
      return <PoiPopover hoverInfo={popoverInfo} mapRef={mapRef} />
    case 'arrival-departure':
      return <BreadcrumbPopover hoverInfo={popoverInfo} offset={[0, -12]} />
    case 'driver':
      return <DriverPopover hoverInfo={popoverInfo} />
    default:
      return null
  }
}
